import { render, staticRenderFns } from "./TableDealer.vue?vue&type=template&id=9785fccc&"
import script from "./TableDealer.vue?vue&type=script&lang=ts&"
export * from "./TableDealer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports